exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-watermark]{position:absolute;min-width:70px;max-width:200px;width:12%;text-align:center;z-index:10}[data-watermark] img{max-width:100%}[data-watermark-bottom-left]{bottom:10px;left:10px}[data-watermark-bottom-right]{bottom:10px;right:42px}[data-watermark-top-left]{top:10px;left:10px}[data-watermark-top-right]{top:10px;right:37px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/watermark/public/watermark.scss
 ** module id = 140
 ** module chunks = 0
 **/